import React from "react";
import { Avatar } from "@answersnow/pkg-theme";
import Typography from "@mui/material/Typography";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";

interface RemoveClinicianConfirmDialogProps {
  open: boolean;
  closeDialog: () => void;
  removeSecondaryClinician: () => void;
  selectedClinician: {
    image_url: string;
    first_name: string;
    last_name: string;
  };
  confirmSent: boolean;
}

const RemoveClinicianConfirmDialog = (props: RemoveClinicianConfirmDialogProps) => {
  const { open, closeDialog, removeSecondaryClinician, selectedClinician, confirmSent } = props;
  return (
    <Dialog
      open={open}
      onClose={closeDialog}
      aria-labelledby="remove-clinician-dialog"
      key="remove-clinician-dialog"
    >
      <DialogTitle>Confirm Remove Clinician</DialogTitle>
      <DialogContent>
        <Stack direction="row" gap={5} alignItems="center">
          <Avatar imageUrl={selectedClinician.image_url} />
          <Stack>
            <Typography component="p" variant="body1">
              You are choosing to remove{" "}
              {selectedClinician.first_name + " " + selectedClinician.last_name} as the secondary
              clinician.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={removeSecondaryClinician} color="primary" disabled={confirmSent}>
          Confirm
        </Button>
        <Button onClick={closeDialog} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveClinicianConfirmDialog;
